import { CircularProgress } from '@mui/material'
import classes from './grid-theme.module.scss'

/**
 * `blocking` is for a save: the grid underneath must not take clicks while its
 * rows are being written (SCRUM-1010 QC item 3).
 */
const GridLoadingOverlay = ({ blocking = false }: { blocking?: boolean }) => (
  <div
    className={blocking ? `${classes.overlay} ${classes.overlayBlocking}` : classes.overlay}
  >
    <CircularProgress size={28} sx={{ color: 'primary.main' }} />
  </div>
)

export default GridLoadingOverlay
